module.exports = __webpack_public_path__ + "img/logo-login.581b2f20.jpg";